import { files, featuredListingsRef } from "@/fireinit.js";
import axios from "axios";
import Vue from "vue";

export default {
  loadAll: async ({ commit, rootState }) => {
    const response = await axios.get(`${rootState.axios.API}actionsCenter`, {
      params: {
        assignedToMe: true,
        status: "New",
      },
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    commit("setList", response.data);
  },
  createJob: async ({ commit, rootState }, job) => {
    const response = await axios
      .post(`${rootState.axios.API}actionsCenter/createJob`, job, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      })
      .then((response) => {
        if (response.data.result == "Error") {
          Vue.notify({
            type: "error",
            duration: 2000,
            title: "There was an error creating this Job",
          });
        } else {
          Vue.notify({
            type: "success",
            duration: 2000,
            title: "The job has been created",
          });
        }
      })
      .catch((err) => {
        Vue.notify({
          type: "error",
          duration: 2000,
          title: "There was an error creating this Job",
        });
      });
  },
  dismissMultiple: async ({ commit, rootState, dispatch }, payload) => {
    const response = await axios
      .post(`${rootState.axios.API}actionsCenter/dismiss`, payload, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      })
      .then((response) => {
        if (response.data.result == "Error") {
          Vue.notify({
            type: "error",
            duration: 2000,
            title: "There was an error dismissing some of those actions",
          });
        } else {
          Vue.notify({
            type: "success",
            duration: 2000,
            title: "Those actions have been dismissed",
          });
        }
      })
      .catch((err) => {
        Vue.notify({
          type: "error",
          duration: 2000,
          title: "There was an error dismissing some of those actions",
        });
      });
    dispatch("loadAll");
  },
};
